import * as React from 'react'
import type { DirectionType, SpaceCompactItemContextType } from '../interface'
import classNames from 'classnames'

export const SpaceCompactItemContext = React.createContext<SpaceCompactItemContextType | null>(null)

export const useCompactItemContext = (prefixCls: string, direction: DirectionType) => {
  const compactItemContext = React.useContext(SpaceCompactItemContext)

  const compactItemClassnames = React.useMemo(() => {
    if (!compactItemContext) return ''

    const { compactDirection, isFirstItem, isLastItem } = compactItemContext
    const separator = compactDirection === 'vertical' ? '-vertical-' : '-'

    return classNames({
      [`${prefixCls}-compact${separator}item`]: true,
      [`${prefixCls}-compact${separator}first-item`]: isFirstItem,
      [`${prefixCls}-compact${separator}last-item`]: isLastItem,
      [`${prefixCls}-compact${separator}item-rtl`]: direction === 'rtl',
    })
  }, [prefixCls, direction, compactItemContext])

  return {
    compactSize: compactItemContext?.compactSize,
    compactDirection: compactItemContext?.compactDirection,
    compactItemClassnames,
  }
}
